/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useCallback, useEffect, useState } from 'react';

import FileSaver from 'file-saver';

import { useForm, Controller } from 'react-hook-form';

import AsyncSelect from 'react-select/async';

import { IoMdArrowBack } from 'react-icons/io';
import { AiOutlineDownload } from 'react-icons/ai';

import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdArrowDropUp,
} from 'react-icons/md';

import { format } from 'date-fns';

import moment from 'moment';

import 'moment/locale/pt-br';

import locale from 'antd/es/date-picker/locale/pt_BR';

import ptBR from 'date-fns/locale/pt-BR';

import { Pagination, Row, Col, Select, DatePicker } from 'antd';

import { ClipLoader } from 'react-spinners';

import { Breadcumbs } from '~/components/Breadcumbs';
import { ButtonBase } from '~/components/Button';
import { useSelector } from 'react-redux';

import history from '~/services/history';

import api from '~/services/api';

import {
  PageTitle,
  BoxContent,
  BoxContentHeader,
  SearchContainer,
  BoxAsyncSelect,
  DatePickerContainer,
  BoxList,
  BoxPagination,
} from './style';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';

const { Option } = Select;

const RegistroDeAcessos = () => {
  const { RangePicker } = DatePicker;

  moment.locale('pt-br');

  const {
    register,
    handleSubmit,
    control,
    watch,
    errors,
    setValue,
  } = useForm();

  const { token, roles } = useSelector(state => state.auth);

  const ROLE_USER = roles.includes('ROLE_USER');
  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  if (ROLE_USER) history.push('/');

  const [data, setData] = useState([]);

  const [totalCount, setTotalCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const [searchText, setSearchText] = useState();

  const [pageCurrent, setPageCurrent] = useState(1);
  const [limit] = useState(5);

  const [directionAsc, setDirectionAsc] = useState(true);

  const [filterType, setFilterType] = useState(
    ROLE_ADMIN ? 'instituicao' : 'descricao'
  );
  const [errorinstitution, setErrorinstitution] = useState(false);
  const [institution, setInstitution] = useState(null);

  const [rangeDate, setRangeDate] = useState('');

  const [orderBy, setOrderBy] = useState('');
  const [searchBy, setSearchBy] = useState('');

  const [downloading, setDownloading] = useState(false);

  const [exportParams, setExportParams] = useState(null);

  // Download CSV

  const saveCSVFile = useCallback(data => {
    const BOM = '\uFEFF';
    const csvData = BOM + data;
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });

    FileSaver.saveAs(blob, 'arquivo-de-dados.csv');
  }, []);

  const exportData = useCallback(async () => {
    setDownloading(true);

    try {
      const response = await api.get(
        `acessos-login/exports${exportParams ? exportParams : ''}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      saveCSVFile(response.data);
    } catch (err) {
      console.log('err', err);
    } finally {
      setDownloading(false);
    }
  }, [exportParams]);

  const getData = useCallback(
    async props => {
      const order = props?.orderBy || '';
      const filter = props?.filter || '';
      const offset = props?.offset || 0;
      const idInst = institution?.value
        ? institution?.value
        : props?.idInstituicao || '';

      const dir = props?.dir;

      setOrderBy(order);
      setSearchBy(filter);

      const params = `?limit=${limit}${filter && `&filter=${filter}`}${idInst &&
        `&idInstituicao=${idInst}`}${
        rangeDate
          ? `&dtLoginInicio=${rangeDate[0]?._i}&dtLoginFim=${rangeDate[1]?._i}`
          : ''
      }&offset=${offset}${order &&
        `&orderBy=${order}&direction=${dir ? 'asc' : 'desc'}`}`;

      setExportParams(params);

      try {
        setLoading(true);

        const response = await api.get(`acessos-login${params}`, {
          headers: {
            Authorization: token,
          },
        });

        setData(response.data);
        setTotalCount(response.headers['total-count']);

        if (!offset) {
          setPageCurrent(1);
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    },
    [rangeDate, institution]
  );

  useEffect(() => {
    getData();
  }, []);

  const paginationChange = async page => {
    setPageCurrent(page);
    const limitOffset = page - 1;
    const offset = page <= 1 ? 0 : limitOffset * limit;

    if (searchText || institution?.value) {
      getData({
        orderBy: orderBy,
        offset: offset,
        filter: searchText,
        dir: directionAsc,
        idInstituicao: institution?.value,
      });

      return;
    }

    getData({
      orderBy: orderBy,
      offset: offset,
      dir: directionAsc,
    });
  };

  const filterAcessos = async ({ search }) => {
    setValue('search', search);
    setSearchText(search);

    getData({
      orderBy: orderBy,
      filter: search,
      idInstituicao: institution?.value,
    });
  };

  const limpaBusca = useCallback(() => {
    setInstitution(null);
    getData();
    setPageCurrent(1);
    setSearchText(null);
    setValue('search', '');
    setRangeDate(null);
  }, []);

  // Filter section

  const theme = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#f3f3f3',
    },
  });

  useEffect(() => {
    if (errorinstitution) {
      setTimeout(() => {
        setErrorinstitution(false);
      }, 6000);
    }
  }, [errorinstitution]);

  const filterInstitution = async (inputValue, callback) => {
    if (!inputValue) {
      return;
    }

    const response = await api.get(
      `instituicoes?limit=10&filter=${inputValue}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = response.data.map(hosp => ({
      value: hosp.id,
      label: hosp.nomeFantasia,
    }));

    callback(data);
  };

  const handleChangeFilter = useCallback(
    value => {
      setSearchText('');
      setFilterType(value);
    },
    [setFilterType, setSearchText]
  );

  useEffect(() => {
    if (institution?.label) {
      filterAcessos({ search: '' });
    }
  }, [institution]);

  // Dates for filter

  const returnMomentDateRange = useCallback((start, finish) => {
    return [moment(start, 'DD/MM/YYYY'), moment(finish, 'DD/MM/YYYY')];
  }, []);

  const handleDate = useCallback(
    dateString => {
      if (dateString[0] && dateString[1]) {
        setRangeDate(returnMomentDateRange(dateString[0], dateString[1]));

        return;
      }

      setRangeDate(null);
    },
    [returnMomentDateRange]
  );

  const BoxSearch = () => {
    return (
      <SearchContainer>
        <form onSubmit={handleSubmit(filterAcessos)}>
          <Select
            style={{ width: 120 }}
            value={filterType}
            onChange={handleChangeFilter}
          >
            {ROLE_ADMIN && <Option value="instituicao">Instituição</Option>}
            <Option value="descricao">Usuário</Option>
            <Option value="dataCriacao">Data</Option>
          </Select>

          {ROLE_ADMIN && filterType === 'instituicao' && (
            <BoxAsyncSelect>
              <AsyncSelect
                cacheOptions
                defaultOptions
                onChange={item => {
                  console.log('item', item);
                  setInstitution(item);
                }}
                loadOptions={filterInstitution}
                placeholder="Pesquise"
                noOptionsMessage={() => 'Pesquise por instituição'}
                loadingMessage={() => 'Carregando...'}
                theme={theme}
              />
            </BoxAsyncSelect>
          )}

          {filterType === 'descricao' && (
            <label htmlFor="search" className="search">
              <MdSearch size={18} color="#619b30" />
              <input
                name="search"
                id="search"
                defaultValue={searchText}
                placeholder="Pesquisar"
                ref={register}
              />
            </label>
          )}

          {filterType === 'dataCriacao' && (
            <DatePickerContainer>
              <RangePicker
                value={rangeDate}
                allowClear={true}
                name="startDate"
                id={`startDate`}
                format="DD/MM/YYYY"
                locale={locale}
                onChange={(value, dateString) => {
                  handleDate(dateString);
                }}
              />
            </DatePickerContainer>
          )}
          <button className="botao-verde" type="submit">
            Buscar
          </button>

          <button
            className="limparBusca"
            type="button"
            onClick={() => limpaBusca()}
          >
            Limpar
          </button>

          <ButtonBase
            variant="secondary"
            onClick={exportData}
            style={{ marginLeft: 10 }}
          >
            <div style={{ marginRight: 4 }}>
              {downloading ? (
                <ClipLoader size={10} color="#fff" loading />
              ) : (
                <AiOutlineDownload size={16} color="#FFF" />
              )}
            </div>
            Exportar
          </ButtonBase>
        </form>
      </SearchContainer>
    );
  };

  return (
    <>
      <Breadcumbs path="registro-de-acessos" pathTitle="Registro de Acessos" />

      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div className="headerInline">
          <div>
            <span>Registros de acesso</span>
            <h3>{institution?.label || ''}</h3>
          </div>

          <BoxSearch />
        </div>
      </PageTitle>

      {!loading && data.length > 0 ? (
        <BoxContent>
          <BoxContentHeader>
            <Row>
              <Col span={8}>
                <ButtonOrderBy
                  isActive={orderBy === 'nomeInstituicao'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getData({
                      orderBy: 'nomeInstituicao',
                      dir: !directionAsc,
                      filter: searchText || '',
                    });
                  }}
                >
                  <span>
                    Instituição{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={7}>
                <ButtonOrderBy
                  isActive={orderBy === 'email'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getData({
                      orderBy: 'email',
                      dir: !directionAsc,
                      filter: searchText || '',
                    });
                  }}
                >
                  <span>
                    E-mail do usuário{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={3}>
                <ButtonOrderBy
                  isActive={orderBy === 'dataLogin'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getData({
                      orderBy: 'dataLogin',
                      dir: !directionAsc,
                      filter: searchText || '',
                    });
                  }}
                >
                  <span>
                    Data{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={3}>
                <ButtonOrderBy
                  isActive={orderBy === 'dataLogin'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getData({
                      orderBy: 'dataLogin',
                      dir: !directionAsc,
                      filter: searchText || '',
                    });
                  }}
                >
                  <span>
                    Hora (Login){' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={3}>
                <ButtonOrderBy
                  isActive={orderBy === 'dataLogout'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getData({
                      orderBy: 'dataLogout',
                      dir: !directionAsc,
                      filter: searchText || '',
                    });
                  }}
                >
                  <span>
                    Hora (Logout){' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>
            </Row>
          </BoxContentHeader>

          {data.map(
            (
              { nomeInstituicao, nomeUsuario, email, dataLogin, dataLogout },
              id
            ) => {
              return (
                <BoxList key={Number(id)}>
                  <Row>
                    <Col span={8}>
                      <div className="nomeUsuario">
                        <span>{nomeInstituicao}</span>
                      </div>
                    </Col>

                    <Col span={7}>
                      <div className="email">
                        <span>{email}</span>
                      </div>
                    </Col>

                    <Col span={3}>
                      <div className="data">
                        <span>
                          {dataLogin &&
                            format(new Date(`${dataLogin}`), 'dd/MM/yyyy', {
                              locale: ptBR,
                            })}
                        </span>
                      </div>
                    </Col>

                    <Col span={3}>
                      <div className="horaLogin">
                        <span>
                          {dataLogin &&
                            format(new Date(`${dataLogin}`), 'HH:mm:ss', {
                              locale: ptBR,
                            })}
                        </span>
                      </div>
                    </Col>

                    <Col span={3}>
                      <div className="horaLogin">
                        <span>
                          {dataLogout &&
                            format(new Date(`${dataLogout}`), 'HH:mm:ss', {
                              locale: ptBR,
                            })}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </BoxList>
              );
            }
          )}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};

export default RegistroDeAcessos;
